const doc = [({"zh_tw":({"adminButtonCompany":({"updateCreditCardFees":"更新付款費用", "updateSystemUsageFees":"更新系統使用費"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;